/**
 * Copy owned by the shell package: tour popover chrome and the tour demo mock
 * UIs. Keys live in the `shell` namespace (`../locales/{vi,en}.json`), which the
 * host registers at bootstrap with `registerShellLocales`.
 *
 * The Vietnamese bundle is also imported here as the fallback, so an extracted
 * shell without an i18n instance (or before the host registered the namespace)
 * still renders Vietnamese, exactly the text it always had.
 */
import { getI18n } from 'react-i18next'
import vi from '../locales/vi.json'

export const SHELL_NS = 'shell'

const lookupVi = (key: string): string | undefined => {
    let node: unknown = vi
    for (const part of key.split('.')) {
        if (node && typeof node === 'object' && part in node)
            node = (node as Record<string, unknown>)[part]
        else return undefined
    }
    return typeof node === 'string' ? node : undefined
}

const interpolate = (text: string, vars?: Record<string, string>): string =>
    vars ? text.replace(/\{\{(\w+)\}\}/g, (_, k) => vars[k] ?? '') : text

/** `shell:<key>` in the current language, else the bundled Vietnamese. */
export const shellText = (
    key: string,
    vars?: Record<string, string>
): string => {
    const i18n = getI18n()
    if (i18n && i18n.exists(key, { ns: SHELL_NS }))
        return String(i18n.t(key, { ns: SHELL_NS, ...vars }))
    return interpolate(lookupVi(key) ?? key, vars)
}

/** Text of a tour demo mock UI: `tour_demo.<demo>.<id>`. */
export const demoText = (
    demo: string,
    id: string,
    vars?: Record<string, string>
): string => shellText(`tour_demo.${demo}.${id}`, vars)
